import { defineMessages } from 'react-intl';

export default defineMessages({
  errorMessage: {
    defaultMessage: 'No eligible shipments selected',
    id: 'dAi+Vx',
    description: 'Prepay duties and taxes error message',
  },
  infoMessage: {
    defaultMessage: 'Prepaid Duties and Taxes can apply only on USPS shipments to Canada. <a>Learn more about DDP</a>',
    id: 'HiNIUt',
    description: 'Prepay duties and taxes info message',
  },
});
